import type { IconSvgObject } from './types';

const WifiMediumSignalIcon: IconSvgObject = [
  ["path", { d: "M20.7487 6.42157C18.3521 4.50087 15.3102 3.35203 12 3.35203C8.68979 3.35203 5.64791 4.50087 3.25132 6.42157C2.49033 7.03145 2.41868 8.13176 2.99097 8.92141L11.1903 20.2348C11.5895 20.7857 12.4105 20.7857 12.8097 20.2348L21.009 8.9214C21.5813 8.13176 21.5097 7.03145 20.7487 6.42157Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.6143 13.6035C14.0455 11.9349 9.95154 11.9349 6.38281 13.6035M15.174 16.9705C13.1211 16.1459 10.876 16.1459 8.82308 16.9705", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WifiMediumSignalIcon;
